<mat-toolbar
  *ngIf="!hideHeader"
  color="primary"
>
  <mat-toolbar-row>
  <div>
    <div style="line-height: 19px!important;">
      <div class="font-size-20 fw-light">RAG Oversight</div>
      <a href="https://saorsa.bg" target="_blank"
        class="font-size-11 mt-0 pt-0 fw-light text-light click-able">
        by
        <span  class="text-light">Saorsa Ltd</span>
      </a>
    </div>
  </div>
  <span class="flex-mid-spacer"></span>
  <div>
    <ng-container
      *ngIf="customButtonsTemplate"
      [ngTemplateOutlet]="customButtonsTemplate"
    >
    </ng-container>
  </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-toolbar class="breadcrumbs-bar" [ngClass]="breadcrumbsClass" *ngIf="!hideHeader">
  <div>
    <div *ngIf="breadcrumbs?.length" class="d-flex align-items-center py-3 fw-light font-size-default">

      <span>
        <a routerLink="/" [queryParams]="{ ref: 'header'}" class="p-0 m-0 link-underline-light">
          <mat-icon class="valign-middle">home</mat-icon>
        </a>
        <span class="mx-2"> | </span>
      </span>

      <span *ngFor="let b of breadcrumbs; let last = last; let index = index">
        <ng-container *ngIf="!b.hideBreadcrumbs">
          <a
            *ngIf="!last"
            class="p-0 m-0 link-underline-light"
            [routerLink]="b.url">{{b.breadCrumbLabel || b.title || b.url | uppercase}}</a>
          <span *ngIf="last">{{b.breadCrumbLabel || b.title || b.url | uppercase}}</span>
          <span *ngIf="!last" class="mx-2"> | </span>
        </ng-container>
      </span>

    </div>
  </div>
</mat-toolbar>

<div *ngIf="lastNavigationItemTemplate">
  <ng-template
    [ngTemplateOutlet]="lastNavigationItemTemplate"
    [ngTemplateOutletContext]="{
      navigationItem: lastNavigationRouteItem,
      debug: debug
    }"
  ></ng-template>
</div>
